import { render } from "./forward-booking-commission-detail-section-commission.vue?vue&type=template&id=4bb4b7b2&ts=true"
import script from "./forward-booking-commission-detail-section-commission.vue?vue&type=script&lang=ts"
export * from "./forward-booking-commission-detail-section-commission.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__